var _0x2f98 = [
  window.location.hostname,
  Shopify.shop,
  "href",
  "location",
  "\x69\x6E\x64\x65\x78\x4F\x66",
  "shopifypreview.com",
  "shopify.com",
  "Unauthorised use of code detected. using the copyrighted code without prior permission.",
  "\x6C\x6F\x67",
  "\x73\x63\x72\x69\x70\x74",
  "getElementsByTagName",
  "length",
  "data-src",
  "getAttribute",
  "\x73\x72\x63",
  "\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75\x74\x65",
  "\x64\x61\x74\x61\x73\x65\x74",
  "\x74\x79\x70\x65",
  "\x74\x65\x78\x74\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74\x73",
  "\x63\x72\x65\x61\x74\x65\x45\x6C\x65\x6D\x65\x6E\x74",
  "\x61\x74\x74\x72\x69\x62\x75\x74\x65\x73",
  "\x6E\x61\x6D\x65",
  "\x76\x61\x6C\x75\x65",
  "\x74\x65\x78\x74\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74",
  "\x69\x6E\x6E\x65\x72\x48\x54\x4D\x4C",
  "\x72\x65\x6D\x6F\x76\x65\x43\x68\x69\x6C\x64",
  "\x70\x61\x72\x65\x6E\x74\x4E\x6F\x64\x65",
  "\x69\x6E\x73\x65\x72\x74\x42\x65\x66\x6F\x72\x65",
  "\x53\x74\x61\x72\x74\x41\x73\x79\x6E\x63\x4C\x6F\x61\x64\x69\x6E\x67",
  "\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76\x65\x6E\x74",
  "\x73\x74\x61\x72\x74\x61\x73\x79\x6E\x63\x6C\x6F\x61\x64\x69\x6E\x67",
  "\x73\x63\x72\x6F\x6C\x6C",
  "\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72",
  "\x6D\x6F\x75\x73\x65\x6D\x6F\x76\x65",
  "\x74\x6F\x75\x63\x68\x73\x74\x61\x72\x74",
  "\x6C\x6F\x61\x64",
  "\x61\x74\x74\x61\x63\x68\x45\x76\x65\x6E\x74",
  "\x6F\x6E\x6C\x6F\x61\x64",
];
var domain_url = _0x2f98[0];
var domain_admin_url = _0x2f98[1];
var current_url = window[_0x2f98[3]][_0x2f98[2]];
if (
  current_url[_0x2f98[4]](domain_url) < 0 &&
  current_url[_0x2f98[4]](domain_admin_url) < 0 &&
  current_url[_0x2f98[4]](_0x2f98[5]) < 0 &&
  current_url[_0x2f98[4]](_0x2f98[6])
) {
  console[_0x2f98[8]](_0x2f98[7]);
} else {
  var script_loaded = false;
  function loadAsync() {
    if (script_loaded) {
      return;
    } else {
      script_loaded = true;
      var _0x9bfax6 = document[_0x2f98[10]](_0x2f98[9]);
      for (var _0x9bfax7 = 0; _0x9bfax7 < _0x9bfax6[_0x2f98[11]]; _0x9bfax7++) {
        if (_0x9bfax6[_0x9bfax7][_0x2f98[13]](_0x2f98[12]) !== null) {
          _0x9bfax6[_0x9bfax7][_0x2f98[15]](
            _0x2f98[14],
            _0x9bfax6[_0x9bfax7][_0x2f98[13]](_0x2f98[12])
          );
          delete _0x9bfax6[_0x9bfax7][_0x2f98[16]][_0x2f98[14]];
        }
        if (_0x9bfax6[_0x9bfax7][_0x2f98[13]](_0x2f98[17]) == _0x2f98[18]) {
          var _0x9bfax8 = document[_0x2f98[19]](_0x2f98[9]);
          for (
            var _0x9bfax9 = 0;
            _0x9bfax9 < _0x9bfax6[_0x9bfax7][_0x2f98[20]][_0x2f98[11]];
            _0x9bfax9++
          ) {
            var _0x9bfaxa = _0x9bfax6[_0x9bfax7][_0x2f98[20]][_0x9bfax9];
            _0x9bfax8[_0x2f98[15]](
              _0x9bfaxa[_0x2f98[21]],
              _0x9bfaxa[_0x2f98[22]]
            );
          }
          _0x9bfax8[_0x2f98[17]] = _0x2f98[23];
          _0x9bfax8[_0x2f98[24]] = _0x9bfax6[_0x9bfax7][_0x2f98[24]];
          _0x9bfax6[_0x9bfax7][_0x2f98[26]][_0x2f98[25]](_0x9bfax6[_0x9bfax7]);
          _0x9bfax6[_0x9bfax7][_0x2f98[26]][_0x2f98[27]](
            _0x9bfax8,
            _0x9bfax6[_0x9bfax7]
          );
        }
      }
      setTimeout(function () {
        document[_0x2f98[29]](new CustomEvent(_0x2f98[28]));
      }, 900);
      document[_0x2f98[29]](new CustomEvent(_0x2f98[30]));
    }
  }
  window[_0x2f98[32]](_0x2f98[31], function (_0x9bfaxb) {
    loadAsync();
  });
  window[_0x2f98[32]](_0x2f98[33], function () {
    loadAsync();
  });
  window[_0x2f98[32]](_0x2f98[34], function () {
    loadAsync();
  });
  if (window[_0x2f98[32]]) {
    window[_0x2f98[32]](
      _0x2f98[35],
      function () {
        setTimeout(loadAsync, 9000);
      },
      false
    );
  } else {
    if (window[_0x2f98[36]]) {
      window[_0x2f98[36]](_0x2f98[37], function () {
        setTimeout(loadAsync, 9000);
      });
    } else {
      window[_0x2f98[37]] = loadAsync;
    }
  }
}

// Temporary Flexi session-credit loader while Shopify serves stale product HTML.
(function () {
  if (window.FlexiSessionCreditHotfixLoader) {
    return;
  }
  window.FlexiSessionCreditHotfixLoader = true;
  function loadFlexiSessionCreditHotfix() {
    if (
      window.FlexiSessionCreditHotfix ||
      document.querySelector("script[data-flexi-session-credit-hotfix]")
    ) {
      return;
    }
    var container = document.getElementById("flexi-addons-container");
    if (!container || !container.getAttribute("data-product-id")) {
      return;
    }
    var script = document.createElement("script");
    script.src =
      "/cdn/shop/t/76/assets/flexi-session-credit-hotfix.js?v=51671981838573922961776914783";
    script.defer = true;
    script.setAttribute("data-flexi-session-credit-hotfix", "");
    document.head.appendChild(script);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadFlexiSessionCreditHotfix);
  } else {
    loadFlexiSessionCreditHotfix();
  }
})();

// Temporary Flexible Deposits product-page shim while canonical product HTML catches up.
(function () {
  if (window.FlexibleDepositsProductShimAsset) {
    return;
  }
  window.FlexibleDepositsProductShimAsset = true;
  function root() {
    return document;
  }
  function selector() {
    return root().querySelector(
      '.deposit-selector[data-native-deposit-checkout="true"]'
    );
  }
  function ready(s) {
    return !!(s && !s.hidden && s.style.display !== "none");
  }
  function depositSelected(s) {
    var r = s && s.querySelector(".deposit-selector__radio:checked");
    return !!(r && r.value === "deposit");
  }
  function nativeContainer(s) {
    return s && s.querySelector('[id^="deposit-native-checkout-container-"]');
  }
  function form() {
    var forms = Array.prototype.slice.call(
      root().querySelectorAll('form[action*="/cart/add"]')
    );
    return (
      forms.find(function (candidate) {
        return !!candidate.querySelector(
          'button[name="add"],input[name="add"],[id^="ProductSubmitButton"],[data-add-to-cart]'
        );
      }) ||
      root().querySelector(
        'form.mainProductForm[action*="/cart/add"],form[data-type="add-to-cart-form"][action*="/cart/add"]'
      ) ||
      forms[0] ||
      null
    );
  }
  function addButtons(f) {
    var q =
      'button[name="add"],input[name="add"],button[type="submit"],input[type="submit"],[data-add-to-cart],[id^="AddToCart"],[id^="ProductSubmitButton"]';
    var pageQ =
      'button[name="add"],input[name="add"],[data-add-to-cart],[id^="AddToCart"],[id^="ProductSubmitButton"]';
    var out = [];
    if (f) {
      f.querySelectorAll(q).forEach(function (b) {
        out.push(b);
      });
    }
    root()
      .querySelectorAll(pageQ)
      .forEach(function (b) {
        if (!f || !b.getAttribute("form") || b.getAttribute("form") === f.id) {
          out.push(b);
        }
      });
    return out.filter(function (b, i, a) {
      return (
        b &&
        a.indexOf(b) === i &&
        !b.closest(".deposit-selector") &&
        !b.hasAttribute("data-fd-shim-cart-add") &&
        !/^deposit-native-/.test(b.id || "")
      );
    });
  }
  function hideButton(b, h) {
    if (!b.dataset.fdShimOriginalDisplaySet) {
      b.dataset.fdShimOriginalDisplaySet = "true";
      b.dataset.fdShimOriginalDisplay = b.style.display || "";
      b.dataset.fdShimOriginalAriaHidden = b.getAttribute("aria-hidden") || "";
    }
    if (h) {
      b.style.setProperty("display", "none", "important");
    } else {
      b.style.removeProperty("display");
      if (b.dataset.fdShimOriginalDisplay) {
        b.style.display = b.dataset.fdShimOriginalDisplay;
      }
    }
    if (h) {
      b.setAttribute("aria-hidden", "true");
    } else if (b.dataset.fdShimOriginalAriaHidden) {
      b.setAttribute("aria-hidden", b.dataset.fdShimOriginalAriaHidden);
    } else {
      b.removeAttribute("aria-hidden");
    }
  }
  function termsOk(s) {
    var t =
      s &&
      s.querySelector(
        'input[id^="deposit-terms-"], .deposit-selector__terms-input'
      );
    if (!t || t.checked) {
      return true;
    }
    alert(
      "Please agree to the Deposit Terms & Conditions before adding to cart."
    );
    t.focus();
    return false;
  }
  function submit(s) {
    var f = form();
    if (!f || !termsOk(s)) {
      return;
    }
    var b = addButtons(f).find(function (x) {
      return !x.disabled;
    });
    if (typeof f.requestSubmit === "function") {
      try {
        f.requestSubmit(b || undefined);
      } catch (error) {
        f.requestSubmit();
      }
      return;
    }
    if (b && typeof b.click === "function") {
      b.click();
      return;
    }
    if (typeof f.submit === "function") {
      f.submit();
    }
  }
  function ensureStyle() {
    if (document.getElementById("fd-product-deposit-shim-style")) {
      return;
    }
    var st = document.createElement("style");
    st.id = "fd-product-deposit-shim-style";
    st.textContent =
      ".deposit-selector__checkout-actions,.fd-product-deposit-shim-actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:12px}.deposit-selector__checkout-actions .deposit-selector__checkout-button,.fd-product-deposit-shim-actions .deposit-selector__checkout-button{flex:1 1 180px}.deposit-selector__checkout-button--secondary{background:#fff;border:1px solid currentColor;color:var(--fd-choice-accent,#111)}body.fd-native-deposit-selected [id^='AddToCart'],body.fd-native-deposit-selected [id^='ProductSubmitButton'],body.fd-native-deposit-selected [data-add-to-cart]{display:none!important}";
    document.head.appendChild(st);
  }
  function bindButton(b, s) {
    if (!b || b.dataset.fdShimAssetTakeoverBound === "true") {
      return b;
    }
    b.dataset.fdShimAssetTakeoverBound = "true";
    b.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submit(s);
      },
      true
    );
    return b;
  }
  function ensureButton(s) {
    var existing = s.querySelector(
      '[id^="deposit-native-cart-add"],[data-fd-shim-cart-add]'
    );
    if (existing) {
      return bindButton(existing, s);
    }
    var c = nativeContainer(s);
    if (!c) {
      return null;
    }
    ensureStyle();
    var checkout = c.querySelector('[id^="deposit-native-checkout"]');
    var actions = c.querySelector(".deposit-selector__checkout-actions");
    if (!actions) {
      actions = document.createElement("div");
      actions.className =
        "deposit-selector__checkout-actions fd-product-deposit-shim-actions";
      c.insertBefore(actions, c.firstChild);
    }
    if (checkout && checkout.parentElement !== actions) {
      actions.appendChild(checkout);
    }
    var b = document.createElement("button");
    b.type = "button";
    b.className =
      "deposit-selector__checkout-button deposit-selector__checkout-button--secondary";
    b.id = "deposit-native-cart-add-global";
    b.setAttribute("data-fd-shim-cart-add", "true");
    b.textContent = "Add deposit to cart";
    b.addEventListener("click", function () {
      submit(s);
    });
    actions.insertBefore(b, actions.firstChild);
    return bindButton(b, s);
  }
  function update() {
    var s = selector();
    if (!s) {
      return;
    }
    var use = ready(s) && depositSelected(s);
    var f = form();
    var b = ensureButton(s);
    if (document.body) {
      document.body.classList.toggle("fd-native-deposit-selected", use);
    }
    addButtons(f).forEach(function (x) {
      hideButton(x, use);
    });
    if (b) {
      b.style.display = use ? "" : "none";
    }
  }
  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches(".deposit-selector__radio")) {
      setTimeout(update, 0);
    }
  });
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest(".deposit-selector__option")) {
      setTimeout(update, 0);
    }
  });
  if (window.MutationObserver) {
    new MutationObserver(function () {
      window.requestAnimationFrame(update);
    }).observe(document, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["class", "hidden", "style", "checked"],
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", update);
  } else {
    update();
  }
  setTimeout(update, 250);
  setTimeout(update, 1000);
  setTimeout(update, 2500);
  setTimeout(update, 5000);
})();
